/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Direct Disposal component for PMD Phase 
Author: Deimos Space UK

Version: 1.0
*/

import React from 'react'
import { Row, Col, Form } from 'react-bootstrap';
import Select from 'react-select';

import style from '../PMDPhase.module.css'
function DirectDisposal(props) {

    return (
        <div>

            <Row className={style.rowForm}>
                <Col xs={6} md={4} >

                    <Select
                        isDisabled={true}
                        className="react-select"
                        classNamePrefix="react-select"
                        value={props.step4?.directDisposalData?.disposalSystem}
                        options={[
                            { value: 'chemical', label: 'Chemical' },
                            { value: 'electrical', label: 'Electrical' },
                        ]}>

                    </Select>
                </Col>
                <Col xs={6} md={4} >

                    <Form.Group className={style.manualInput} controlId="endDate">
                        <Form.Label>Target perigee altitude [km]</Form.Label>
                        <Form.Control
                            isInvalid={isNaN(props?.step4?.directDisposalData?.targetPerigee) && props?.step4?.directDisposalData?.targetPerigee !== ''} 
                            disabled={props.disabled}
                            value={props.step4?.directDisposalData?.targetPerigee}
                            onChange={e => props.changeTargetPerigee(e.target.value)} type="string" />
                    </Form.Group>
                </Col >

            </Row>

        </div>
    )
}

export default DirectDisposal